import { api_ } from '@shared/plugIn/axios';

import { AcqMsg, AcqMsgCreate, AcqMsgUpdate } from './acqMsg.interface';

const BASE_PATH = 'public/acq-msg';

export const getAcqMsgList = async (feventId: string): Promise<AcqMsg[]> => {
  const filter = JSON.stringify({ fevent: feventId });
  const options = JSON.stringify({ sort: { createdAt: -1 } });
  const { data } = await api_.get<AcqMsg[]>(
    `${BASE_PATH}?filter=${encodeURIComponent(filter)}&options=${encodeURIComponent(options)}`,
  );
  return data;
};

export const createAcqMsg = async (body: AcqMsgCreate): Promise<AcqMsg> => {
  const { data } = await api_.post<AcqMsg>(BASE_PATH, body);
  return data;
};

export const updateAcqMsg = async (
  id: string,
  body: AcqMsgUpdate,
): Promise<AcqMsg> => {
  const { data } = await api_.patch<AcqMsg>(`${BASE_PATH}/${id}`, body);
  return data;
};

export const deleteAcqMsg = async (
  id: string,
  password: string,
): Promise<AcqMsg> => {
  const { data } = await api_.delete<AcqMsg>(`${BASE_PATH}/${id}`, {
    data: { password },
  });
  return data;
};

export const deleteAcqMsgByMember = async (
  id: string,
  memberId: string,
): Promise<AcqMsg> => {
  const { data } = await api_.delete<AcqMsg>(
    `${BASE_PATH}/${id}/by-member/${memberId}`,
  );
  return data;
};
